module.exports = __webpack_public_path__ + "static/media/google-login-card.eeab1545.png";